import { MoonIcon, SunIcon } from "@phosphor-icons/react";
import { useContext, ReactNode, useState, createContext, useEffect } from "react";

type Theme = 'light' | 'dark';

interface ThemeContextType {
    theme: Theme;
    toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};

interface ThemeProviderProps {
    children: ReactNode;
}
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
    const [theme, setTheme] = useState<Theme>(
        localStorage.getItem('theme') as Theme || 'light'
    );

    useEffect(() => {
        document.documentElement.classList.toggle('dark', theme === 'dark');
    }, [theme]);

    const toggleTheme = () => {
        const next = theme === 'light' ? 'dark' : 'light';
        setTheme(next);
        localStorage.setItem('theme', next);
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}
const ThemeSwitch = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        
        <button onClick={toggleTheme} className="p-2 rounded hover:cursor-pointer">
           {theme === 'light'
               ? <SunIcon size={24} color="#374151" />
               : <MoonIcon size={24} color="#ffffff" />}
        </button>
    );
}

const light = {
    backgroundNone: '#f0f0f0',
    backgroundBase: '#ffffff',
    backgroundBaseSecondary: '#f9f9f9',
    foreground: '#000000',
    foregroundSecondary: '#555555',
    backgroundCard: '#f0f0f0',
    textPrimary: '#000000',
    textSecondary: '#555555',
    textblur: 'rgba(0,0,0,0.88)',
    borderColor: '#e0e0e0',
    buttonTrigger: '#3b82f6',

}
const dark = {
    backgroundNone: '#111827',
    backgroundBase: '#121212',
    backgroundBaseSecondary: '#1f2937',
    foreground: '#ffffff',
    foregroundSecondary: '#bbbbbb',
    backgroundCard: '#1e1e1e',
    textPrimary: '#ffffff',
    textSecondary: '#bbbbbb',
    textblur: 'rgba(255,255,255,0.88)',
    borderColor: '#333333',
    buttonTrigger: '#3b82f6',
}
export { light, dark , ThemeSwitch };